import CryptoJs from 'crypto-js'

export const encryptedTime = (time: Date) => {
  const message = JSON.stringify({
    key: import.meta.env.VITE_REACT_APP_API_KEY,
    expirationDate: time,
  })

  // Compatível com o backend: adiciona salt vazio (string.Empty)
  const salt = ''
  const messageWithSalt = message + salt

  const encrypted = CryptoJs.AES.encrypt(
    CryptoJs.enc.Utf8.parse(messageWithSalt),
    CryptoJs.enc.Utf8.parse(import.meta.env.VITE_REACT_APP_AES_KEY),
    {
      iv: CryptoJs.enc.Utf8.parse(import.meta.env.VITE_REACT_APP_AES_IV),
      mode: CryptoJs.mode.CBC,
      padding: CryptoJs.pad.Pkcs7,
    },
  )
  
  return encrypted
}
